import { action, observable, reaction, runInAction } from 'mobx';
import { toastr } from 'react-redux-toastr';

import APPConf from 'lib/config/common';
import { notificationsController } from './notificationsController';
import { ClientNotificationsControlRequest } from '../api/notificationsApi';
 
export interface ClientNotificationsHistory {
  [key: string]: any
}

export interface ClientNotificationsStore {
  history: ClientNotificationsHistory[],
  error: string,
}

export interface GetNotificationsHistoryAction {
  clientId: string,
  orderId: string,
}

export const clientNotificationsStore: ClientNotificationsStore = observable<ClientNotificationsStore>({
  history: [],
  error: null,
});

export const clientNotificationsActions = {
  getNotificationsHistory: async (request: GetNotificationsHistoryAction): Promise<void> => {
    const response = await notificationsController.getNotificationsHistory(request);

    runInAction(() => {
      if (response.errorData) {
        clientNotificationsStore.error = response.errorData.message;
      }

      clientNotificationsStore.history = response.data;
    });
  },
  updateNotificationsControl: async (request: ClientNotificationsControlRequest): Promise<void> => {
    const response = await notificationsController.updateNotificationsControl(request);

    runInAction(() => {
      if (response.errorData) {
        clientNotificationsStore.error = response.errorData.message;
      }
    });
  },
  clearError: action(() => {
    clientNotificationsStore.error = null;
  }),
};

reaction(() => !!clientNotificationsStore.error, () => {
  toastr.error(APPConf.errorHdr, clientNotificationsStore.error);
});
